export default __webpack_public_path__ + "static/media/dashboard-active.bcf4ccd1.svg";